const HISTORY_SIZE = 200;
const UPDATE_INTERVAL = 250; // ms between text refresh

export class FpsGraph {
  private el: HTMLSpanElement;
  private frameTimes: Float32Array = new Float32Array(HISTORY_SIZE);
  private head = 0;
  private count = 0;
  private sorted: Float32Array = new Float32Array(HISTORY_SIZE);
  private lastUpdate = 0;

  constructor(container: HTMLElement) {
    this.el = document.createElement('span');
    container.appendChild(this.el);
  }

  update(dt: number): void {
    this.frameTimes[this.head] = dt * 1000;
    this.head = (this.head + 1) % HISTORY_SIZE;
    if (this.count < HISTORY_SIZE) this.count++;

    const now = performance.now();
    if (now - this.lastUpdate > UPDATE_INTERVAL) {
      this.lastUpdate = now;
      this.refresh();
    }
  }

  private refresh(): void {
    if (this.count < 2) {
      this.el.textContent = 'FPS: --';
      return;
    }

    const n = this.count;
    for (let i = 0; i < n; i++) {
      this.sorted[i] = this.frameTimes[(this.head - n + i + HISTORY_SIZE) % HISTORY_SIZE];
    }
    const slice = this.sorted.subarray(0, n);
    slice.sort();

    const median = slice[Math.floor(n / 2)];
    const p90 = slice[Math.max(0, Math.ceil(n * 0.90) - 1)];
    const p95 = slice[Math.max(0, Math.ceil(n * 0.95) - 1)];
    const p99 = slice[Math.max(0, Math.ceil(n * 0.99) - 1)];

    const fps = median > 0 ? Math.round(1000 / median) : 0;
    const low10 = p90 > 0 ? Math.round(1000 / p90) : 0;
    const low5 = p95 > 0 ? Math.round(1000 / p95) : 0;
    const low1 = p99 > 0 ? Math.round(1000 / p99) : 0;

    this.el.textContent = `FPS: ${fps}  1%: ${low1}  5%: ${low5}  10%: ${low10}`;
  }

  dispose(): void {
    this.el.remove();
  }
}
